/*
 * Grid layout component. Cells can contain other components.
 */

import React from 'react';
import GridLayout from './grid_layout.jsx';

export default class AdaliaMEExternalEntityGrid extends GridLayout {

  static get TYPE() {
    return 'adalia_me_external_entity_grid';
  }

  static dropComponent(dropArea, targetContent, droppedContent, components, isNested) {
    // Pass content from parent
    droppedContent.endpoint = targetContent.endpoint;
    droppedContent.parentExternalEntityAccessor = targetContent.parentExternalEntityAccessor;
    return super.dropComponent(dropArea, targetContent, droppedContent, components, isNested);
  }

  renderView() {
    return super.renderView()
  }
}